import { Component, OnInit, ComponentFactoryResolver, ViewChild, ViewContainerRef, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import { ScriptService } from '../Services/ScriptLoader/script.service';
import { AlertDialogService } from '../Services/Alert/alert.service';
import { PropertiesService } from '../Services/Properties/properties.service';
// import { RightSidenavComponent } from '../right-sidenav/right-sidenav.component';
// import { SidenavService } from '../right-sidenav/sidenav.service';
import { HttpRequestService } from '../Services/Http/http-request.service';
import { HttpClient } from '@angular/common/http';
// import { ChangePasswordComponent } from '../FF-OP/change-password/change-password.component';
// import { ProfileUploadComponent } from '../FF-OP/profile-upload/profile-upload.component';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { MatSidenav, MatDialog } from '@angular/material';
import { PopupComponent } from '../Project/popup/popup.component';
declare var $: any;
@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {
  @HostListener('contextmenu', ['$event'])
  onRightClick(event) {
    event.preventDefault();
  }

  //urlppt: string =
  //  "https://view.officeapps.live.com/op/embed.aspx?src=  http://www.dickinson.edu/download/downloads/id/1076/sample_powerpoint_slides.pptx";

  // urlSafe: SafeResourceUrl;


  // @HostListener('window:unload', [ '$event' ])
  // unloadHandler(event) {
  //   // ...
  //   this.httpRequestService.get("https://api.telegram.org/bot1043512291:AAHSCmWo93PCtzoyXP7U_wHWVglnAHCe-oo/sendmessage?chat_id=528908628&text=APllication  Down: " + 'Joel')
  //   .then((res: any) => {

  //   });
  //   // alert('closed1');
  //   // console.log('Closed1');
  // }

  // @HostListener('window:beforeunload', [ '$event' ])
  // beforeUnloadHandler(event) {
  //   // ...
  //   this.httpRequestService.get("https://api.telegram.org/bot1043512291:AAHSCmWo93PCtzoyXP7U_wHWVglnAHCe-oo/sendmessage?chat_id=528908628&text=APllication  Down: " + 'Joel')
  //   .then((res: any) => {

  //   });
  //   // alert('closed2');
  //   // console.log('Closed2');
  // }
  public toggleActive: any = false;
  public MenuprogressBarShow: any = false;
  userId: number;
  iconTarget: any;
  uri: string = this.property.WebAPIipAndPort.concat(this.property.BSSAPI);
  Weburi: string = this.property.WebAPIipAndPort.concat(this.property.BSSAPI);
  switchOuList: any;
  selectOu: any;
  switcBranchList: any;
  selectBranch: any;
  imageFile: any = "../../assets/images/user-icon.png";
  customsubMenuRate: any = [{ name: "Buy Rate", link: 'BuyRateExport' }, { name: "Sell Rate", link: 'SellRateExport' }];
  customsubMenuJob: any = [{ name: "Export Job", link: 'ExportJob' }, { name: "Import Job", link: 'ImportJob' }];
  customsubMenuBooking: any = [{ name: "Import Sea", link: 'SeaExportFCL' }, { name: "Export Sea", link: 'RFQ' }];
  custommainMenuSea: any = [{ name: "Booking", Title: this.customsubMenuBooking, Icon: 'fa fa-book nav-icon' }, { name: "Job", Title: this.customsubMenuJob, Icon: 'fa fa-cog nav-icon' }, { name: "Rate", Title: this.customsubMenuRate, Icon: 'fa fa-cog nav-icon' }];
  // custommainMenuAir: any = [{ name: "Rate", Title: this.customsubMenuRate, Icon: 'fa fa-book nav-icon' }, { name: "Job", Title: this.customsubMenuJob, Icon: 'fa fa-cog nav-icon' }];
  customMenu: any = [{ name: "Loading", Title: this.custommainMenuSea, Icon: 'fa fa-cog nav-icon' }];
  MainMenuList: any = [];
  SubMenuList: any = [];
  MenuList: any = [];
  ProfileUrl: any;

  @ViewChild('container', { read: ViewContainerRef, static: true }) viewContainerRef: ViewContainerRef;

  constructor(private router: Router, private script: ScriptService,
    private alert: AlertDialogService,
    private componentFactoryResolver: ComponentFactoryResolver,
    public property: PropertiesService,
    private httpRequestService: HttpRequestService,
    private http: HttpClient,
    public dialog: MatDialog,
    public sanitizer: DomSanitizer,
  ) { }
  @ViewChild('searchDrawer', { static: false }) searchSidenav: MatSidenav;
  @ViewChild('searchDrawer1', { static: false }) searchSidenav1: MatSidenav;
  menuData: any;
  mainMenu: any;
  subMenu: any;
  linkMenu: any;
  LastLogin: any;

  ngOnInit() {
   
    // this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(this.urlppt);
    try {
      this.property.ProjectID = Number(sessionStorage.getItem('BLISS_ProjectID'));
    } catch (er) {

    }
    // this.branchSwitchCombo();

    // console.log(this.property.userName);
    // switchBranch: ['', []];
    this.setProperty();
    // this.ProfileUrl=this.property.ProfileUrl;
    // this.LastLogin=this.property.LastLogin;
    // alert(this.property.LastLogin);
    this.getAllMenu();
  }

  setProperty() {
    this.property.userId = sessionStorage.getItem('UserId');
    this.property.gAgentID = Number(sessionStorage.getItem('gAgentID'));
    this.property.userName = sessionStorage.getItem('UserName');
    this.property.roleId = sessionStorage.getItem('RoleId');
    this.property.DefaultOutID = sessionStorage.getItem('DefaultOutID');

    this.property.userMail = sessionStorage.getItem('UserEmail');
    this.property.LastLogin = sessionStorage.getItem('LastLogin');
    this.property.ProfileUrl = sessionStorage.getItem('ProfileUrl');

    this.property.loginID = sessionStorage.getItem('loginID');
    // this.property.ProfileUrl= "../../assets/img/profiles/img-6.jpg";
  }

  dashbMeu(event) {
    $('[menu-icon]').removeClass('active');
    $('[menu-open]').removeClass('menu-open');
    $('[finalmenu-icon]').removeClass('active');
    $(event.target).closest('.has-treeview').find('.second-menu').addClass('active');
  }
  loadSubMeu(event) {
    //  $('[menu-open]').removeClass('active');
    $('[menu-icon]').removeClass('active');
    $(event.target).closest('.has-treeview').find('.second-menu').addClass('active');
  }
  loadFinalMeu(event) {
    $('[finalmenu-icon]').removeClass('active');
    $(event.target).closest('.nav-item').find('a').addClass('active');
  }
  RouteHR() {
    this.router.navigate(["home/HRManual"]);
  }
  openPortMaster() {
    this.router.navigate(["home/portMaster"]);
  }
  openImportInvoice() {
    this.router.navigate(["home/SeaImportInvoice"]);
  }
  openImportBuyRate() {
    this.router.navigate(["home/SeaImportBuyRate"]);
  }
  openImportSellRate() {
    this.router.navigate(["home/SeaImportSellRate"]);
  }
  openQuotation() {
    this.router.navigate(["home/Quotation"]);
  }

  openImportBooking() {
    this.router.navigate(["home/SeaImportBooking"]);
  }
  openBooking() {
    this.router.navigate(["home/SeaExportFCL"]);
  }
  openBookingVesselSchedule() {
    this.router.navigate(["home/BookingVessel"]);
  }
  openJob() {
    this.router.navigate(["home/ExportJob"]);
  }
  openBL() {
    this.router.navigate(["home/HouseBL"]);
  }
  openBilling() {
    this.router.navigate(["home/Billing"]);
  }
  openInvoice() {
    this.router.navigate(["home/Invoice"]);
  }
  OpenChangePw() {
    this.router.navigate(["home/ChangePassword"]);
  }
  goHRManual() {
    this.router.navigate(["home/HRManual"]);
  }
  openVesselSchedule() {
    this.router.navigate(["home/Vesselschedule"]);
  }
  closeSideNav() {
    this.searchSidenav.close();
    this.searchSidenav1.close();
  }
  openRightMenu() {
    var scope = this;
    setTimeout(function () {
      scope.searchSidenav.close();
      scope.searchSidenav1.open();
    }, 100)
  }
  onActivate(componentReference) {
    componentReference.searchItem.subscribe(() => {
      this.closeSideNav();
    })
  }
  onSearchChange(searchValue: string): void {
    console.log(searchValue);
    //it.name.toLowerCase().includes(searchText);
    //let fnem: any;
    //fnem = this.customMenu.SubMenu;
    //console.log(fnem);
    //  this.customMenu = this.customMenu.filter(s => s.SubMenu.LinkMenu.toLowerCase()(searchValue));
  }
  searchMenu(event) {
    console.log(event);
  }
  getMenu() {
    // if (sessionStorage.getItem('menu')) {
    //   let menu: any = JSON.parse(sessionStorage.getItem('menu'));
    //   this.customMenu = menu;
    // } else {
    // this.authGuard.canActivate().then((response: any) => {
    this.MenuprogressBarShow = true;
    this.http.get(this.uri + '/menu/getAllMenu', { params: { ouId: '1', userId: this.property.userId, roleId: this.property.roleId } }).subscribe(
      ((res: any) => {
        this.MenuprogressBarShow = false;
        this.customMenu = res.result;
        sessionStorage.setItem('menu', JSON.stringify(res.result));
      }),
      (errorResponse => {
        throw new Error(errorResponse.error.error_description);
      }
      ));
    // });
    // }
  }

  getAllMenu() {

    if (!this.property.userId || this.property.userId == "" || this.property.userId == null) {
      this.alert.openSnackBar('Invalid Session', '2');
      this.router.navigate(["/login"]);
    } else {
      this.MenuprogressBarShow = true;
      this.http.get(this.Weburi + '/menu/getAllMenuListNew', { params: { ouId: this.property.DefaultOutID, userId: this.property.userId, ProjectId: this.property.ProjectId.toString() } }).subscribe(
        // this.http.get(this.Weburi + '/menu/getAllMenuListNew', { params: { ouId: '28', userId: "33", ProjectId: this.property.ProjectId.toString() } }).subscribe(
        ((res: any) => {
          this.MenuprogressBarShow = false;
          res.result.Table2.forEach(element => {
            if (element.linkName == "Dashboard") {
              element.linkicon = "lnr lnr-home";
            }
            else if (element.linkName == "Employees") {
              element.linkicon = "lnr lnr-users";
            }
            else if (element.linkName == "HR") {
              element.linkicon = "lnr lnr-apartment";
            }
            else if (element.linkName == "Career") {
              element.linkicon = "lnr lnr-briefcase";
            }
            else if (element.linkName == "Assets") {
              element.linkicon = "lnr lnr-laptop-phone";
            }
            else if (element.linkName == "Document Upload") {
              element.linkicon = "lnr lnr-cloud-upload";
            } else if (element.linkName == "Onboarding Request" || element.linkName == "Onboarding") {
              element.linkicon = "lnr lnr-users";
            }
            else {
              element.linkicon = "lnr lnr-lock";
            }
          });

          this.MainMenuList = res.result.Table2;

          console.log(this.MainMenuList);
          // sessionStorage.setItem('menu', JSON.stringify(res.result));
        }),
        (errorResponse => {
          throw new Error(errorResponse.error.error_description);
        }
        ));
    }

  }

  // getAllMenu() {
  //   this.MenuprogressBarShow = true;
  //   this.http.get(this.Weburi + '/menu/Get_Menu_New', { params: { ouId: '1', userId: this.property.userId, roleId: this.property.roleId } }).subscribe(
  //     ((res: any) => {
  //       this.MenuprogressBarShow = false;
  //       this.MainMenuList = res;
  //       sessionStorage.setItem('menu', JSON.stringify(res.result));
  //     }),
  //     (errorResponse => {
  //       throw new Error(errorResponse.error.error_description);
  //     }
  //     ));
  // }

  branchSwitchCombo() {
    // console.log('Branch switch combo: ' + sessionStorage.getItem('UserId'));
    if (!this.property.userId) {
      this.property.userId = sessionStorage.getItem('UserId');
      this.property.userName = sessionStorage.getItem('UserName');
      this.property.roleId = sessionStorage.getItem('RoleId');
      this.property.userMail = sessionStorage.getItem('UserEmail');
      this.property.loginID = sessionStorage.getItem('loginID');
    }
    // this.authGuard.canActivate().then((response: any) => {
    this.http.get(this.property.WebAPIipAndPort.concat(this.property.BSSAPI) + '/branch/branchMasterList', { params: { userId: this.property.userId } }).subscribe((res: any) => {
      if (res.status == 200) {
        this.switcBranchList = res.result.Table;
        this.property.branchId = res.result.Table[0].Value;
        this.property.branchCode = res.result.Table[0].BranchCode;
        this.property.branchCurrency = res.result.Table[0].CurrencyCode;
        this.property.OuCode = 1;
        this.property.ouId = 1;
        this.selectBranch = res.result.Table[0].Value;
        this.GetProfileImage();
      } else {
        this.alert.openSnackBar("ERROR", res.message + " : " + res.result);
      }
    }, (error: any) => {
      console.log(error);
      this.alert.openSnackBar("ERROR", error);
    });
    // });
  }
  swithBranch(event) {
    sessionStorage.clear();
    sessionStorage.setItem('UserId', this.property.userId);
    sessionStorage.setItem('UserName', this.property.userName);
    sessionStorage.setItem('RoleId', this.property.roleId);
    sessionStorage.setItem("branchId", event.value);
    sessionStorage.setItem("ouId", this.property.ouId);
    this.switcBranchList.forEach(item => {
      if (item.Value == event.value) {
        this.property.OuCode = 1;
        this.property.ouId = 1;
        this.property.branchCode = item.BranchCode;
        this.property.branchId = event.value;
        this.property.branchCurrency = item.CurrencyCode;
        sessionStorage.setItem("branchCode", item.BranchCode);
        sessionStorage.setItem("branchCurrency", item.CurrencyCode);
      }
    });
    this.router.navigate(["/home"]);
    // this.router.navigate(['/home/Dashboard']);
  }
  // getUserId() {
  //   this.httpRequestService.get(this.uri + "/user/userInfo").then((res: any) => {
  //     this.userId = res.result;
  //     console.log('Get UserID: ' + this.property.userId);
  //     this.property.userId = 1;
  //   });
  // }

  //#region Profile Image View
  GetProfileImage() {
    this.getImageProfile().then((list: any) => {
      if (list.result.Table[0].ProfilePicPath) {
        this.imageDownload(list.result.Table[0].ProfilePicPath);
      } else {
        this.imageFile = "../../assets/images/user-icon.png";
      }

      this.router.navigate(['/home/dashboard']);
      //this.alert.openSnackBar(list.message, '');
    });
  }
  getImageProfile() {

    return new Promise((resolve, reject) => {
      this.httpRequestService.get(this.Weburi + "/user/getProfilePic?UserId=" + this.property.userId)
        .then((res: any) => {
          if (res.status == 200) {
            resolve(res);
          }
        }, (error) => {
          reject(error);
        });
    });
  }
  imageDownload(row) {
    this.http.get(this.uri + "/imageUpload/downloadFile/" + row)
      .subscribe((data: any) => {
        if (data && data.base64) {
          let binaryString = window.atob(data.base64);
          let binaryLen = binaryString.length;
          let bytes = new Uint8Array(binaryLen);
          for (let i = 0; i < binaryLen; i++) {
            let ascii = binaryString.charCodeAt(i);
            bytes[i] = ascii;
          }
          let file = new Blob([bytes], { type: data.contentType });
          var fileURL = URL.createObjectURL(file);
          this.imageFile = fileURL;
          // window.open(fileURL);
        } else {
          this.imageFile = "../../assets/images/user-icon.png";
          //this.imageFile = "https://www.w3schools.com/howto/img_avatar.png";
        }
      });
  }

  OpenPopupMenu(menuName) {
    const dialogRef = this.dialog.open(PopupComponent, {
      width: '95%', disableClose: true, height: '100%',
      data: { id: 1, componentName: menuName }
    });
  }

  logOutApp() {
    sessionStorage.clear();
    this.router.navigate(["/login"]);
    setTimeout(function () { window.location.reload(); }, 5);
  }
  //#endregion
}
